import { render, staticRenderFns } from "./FeeList.vue?vue&type=template&id=218fb229"
import script from "./FeeList.vue?vue&type=script&lang=js"
export * from "./FeeList.vue?vue&type=script&lang=js"
import style0 from "./FeeList.vue?vue&type=style&index=0&id=218fb229&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports